import React from 'react'

import { PureButton } from '../../ui/pure-button/pure-button'

type ErrorPageProps = {
  status: number
  message: string
}

export const ErrorPage = ({ status, message }: ErrorPageProps) => {
  const reloadPage = () => {
    // eslint-disable-next-line no-undef
    window.location.reload()
  }

  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <h1>Error {status}</h1>
      <p>{message}</p>
      <PureButton onClick={reloadPage}>Reload page</PureButton>
    </div>
  )
}
